"use strict";
import {types} from 'Subschema'
const substitute = types.SubstituteMixin;

export default function minlength$config(options) {
    if (!options.length) throw new Error('Missing required length for minlength validator');
    options = {
        type: 'minlength',
        dataType: 'string',
        message: `Need at least ${options.length} charecters`,
        ...options
    };
    const msg = substitute(options.message);

    return function minlength(val, vm) {
        var value = val;
        if (options.dataType === 'number') {
            value = (val || '').replace(/\D+?/g, '');
        }
        if (value && value.length < options.length) {
            const data = vm ? {...vm.getValue(), options} : {options};
            return {
                level: options.level,
                message: msg.format(data),
                length: val.length,
                type: options.type
            }
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/validators/minlength.js
 **/